<template>
  <v-container fluid>
    <v-card class="mb-2">
      <v-card-title primary-title>
        <h3 class="headline mb-0">BL確認完了送信</h3>
      </v-card-title>
      <v-card-actions>
        <v-btn @click="search()" class="btn-search" v-permit.SHARP_BCE_SEARCH>{{
          $t("app.buttons.search")
        }}</v-btn>
        <v-btn
          :disabled="selected.length !== 1"
          @click="infoInput"
          v-permit.SHARP_BCE_ACTUAL_INFO_INPUT
          >ActualInfo Input</v-btn
        >
        <v-btn
          :disabled="selected.length !== 1 || hasAllUnpaid"
          @click="blSend"
          v-permit.SHARP_BCE_CONFIRM_EMAIL
          >確認完了通知メール</v-btn
        >
        <v-btn :disabled="!hasParam" @click="downloadData()"
          >BL確認データ出力</v-btn
        >
        <v-btn @click="$clearQuery()">検索条件クリア</v-btn>
      </v-card-actions>
    </v-card>

    <v-card>
      <v-form>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                :label="$t('app.labels.partner')"
                url="companies/kvt?type=PARTNER"
                v-model="query.partnerId"
              ></remote-autocomplete>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-text-field
                clearable
                label="D/O NO"
                v-model="query.doNo"
              ></v-text-field>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-text-field
                clearable
                label="B/L NO"
                v-model="query.blNo"
              ></v-text-field>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-layout row wrap>
                <v-flex md6 pr-2 sm6 xs6>
                  <date-picker
                    label="B/L DATE"
                    v-model="query.blIssueDateFrom"
                  ></date-picker>
                </v-flex>
                <v-flex md6 pl-2 sm6 xs6>
                  <date-picker
                    :min="query.blIssueDateFrom"
                    label="~"
                    v-model="query.blIssueDateTo"
                  ></date-picker>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <remote-select
                label="運送形態"
                url="transport-modes/kv"
                v-model="query.transportModeId"
              />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-select
                :items="item"
                clearable
                item-text="text"
                item-value="value"
                label="送信状態"
                v-model="query.blSend"
              ></v-select>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                label="SJL輸入担当"
                url="employees/kv"
                v-model="query.roleId"
              ></remote-autocomplete>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-layout row wrap>
                <v-flex md6 pr-2 sm6 xs6>
                  <date-picker
                    label="ETD"
                    v-model="query.etdFrom"
                  ></date-picker>
                </v-flex>
                <v-flex md6 pl-2 sm6 xs6>
                  <date-picker
                    :min="query.etdFrom"
                    label="~"
                    v-model="query.etdTo"
                  ></date-picker>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
    <v-card class="mt-2">
      <v-data-table
        :headers="headers"
        :items="results"
        :loading="loading"
        :pagination.sync="pagination"
        :rows-per-page-items="[10]"
        :total-items="pagination.totalItems"
        item-key="id"
        select-all
        v-model="selected"
      >
        <template slot="items" slot-scope="props">
          <td>
            <v-checkbox
              hide-details
              primary
              v-model="props.selected"
            ></v-checkbox>
          </td>
          <td>{{ props.item.buCode }}:{{ props.item.buName }}</td>
          <td>{{ props.item.partnerName }}</td>
          <td>{{ props.item.doNo }}</td>
          <td>{{ props.item.blNo }}</td>
          <td>{{ props.item.blSend == true ? "送信済み" : "未送信" }}</td>
          <td>{{ props.item.blIssueDate }}</td>
          <td>{{ props.item.transportModeCode }}</td>
          <td>
            {{
              props.item.totalM3 | currency({ symbol: "", fractionCount: 3 })
            }}
          </td>
          <td>
            {{
              props.item.totalGW | currency({ symbol: "", fractionCount: 3 })
            }}
          </td>
          <td>
            {{
              props.item.actualCw | currency({ symbol: "", fractionCount: 3 })
            }}
          </td>
          <td>
            {{
              props.item.actualGw | currency({ symbol: "", fractionCount: 3 })
            }}
          </td>
          <td>
            {{
              props.item.actualM3 | currency({ symbol: "", fractionCount: 3 })
            }}
          </td>
          <td>{{ props.item.eta }}</td>
          <td>{{ props.item.dischargePortCode }}</td>
          <td>{{ props.item.senderName }}</td>
          <td>{{ props.item.sendDate }}</td>
        </template>
      </v-data-table>
      <bl-dialog
        :shipment="selected.length != 0 && selected[0]"
        @refresh="refresh()"
        ref="blDlg"
      ></bl-dialog>
      <employee-dialog
        :employees="employee"
        @refresh="load()"
        ref="employeeDialog"
      ></employee-dialog>
    </v-card>
    <confirm-3-dialog
      ref="confirm3"
      @confirm="confirm"
      @reject="reject"
      @cancel="cancel"
    ></confirm-3-dialog>
  </v-container>
</template>
<script>
import blDialog from "./dialog";
import EmployeeDialog from "./EmployeeDialog";
import Confirm3Dialog from "../../components/Confirm3Dialog";
export default {
  components: { blDialog, EmployeeDialog, Confirm3Dialog },
  data() {
    return {
      status: "",
      showDialog: false,
      selected: [],
      loading: false,
      employee: [],
      headers: [
        { text: "事業本部", value: "buName", sortable: false },
        { text: "海外取引先", value: "partnerName", sortable: false },
        { text: "D/O NO", value: "doNo", sortable: false },
        { text: "B/L NO", value: "blNo", sortable: false },
        { text: "送信状態", value: "blSend", sortable: false },
        { text: "B/L Date", value: "blIssueDate", sortable: false },
        { text: "運送形態", value: "transportModeCode", sortable: false },
        { text: "Total M3", value: "totalM3", sortable: false },
        { text: "Total GW", value: "totalGw", sortable: false },
        { text: "Air C/W Actual", value: "actualCw", sortable: false },
        { text: "G/W Actual", value: "actualGw", sortable: false },
        { text: "M3 Actual", value: "actualM3", sortable: false },
        { text: "ETA", value: "eta", sortable: false },
        { text: "陸揚港", value: "dischargePortCode", sortable: false },
        { text: "送信者", value: "senderName", sortable: false },
        { text: "送信時間", value: "sendDate", sortable: false },
      ],
      downloadHeaders: [
        { text: "事業本部名", value: "bu", sortable: false },
        { text: "海外取引先", value: "partnerName", sortable: false },
        { text: "D/O NO", value: "doNo", sortable: false },
        { text: "B/L NO", value: "blNo", sortable: false },
        { text: "送信状態", value: "blSend", sortable: false },
        { text: "B/L Date", value: "blIssueDate", sortable: false },
        { text: "運送形態", value: "transportModeCode", sortable: false },
        { text: "Total M3", value: "totalM3", sortable: false },
        { text: "Total GW", value: "totalGW", sortable: false },
        { text: "Air C/W Actual", value: "actualCw", sortable: false },
        { text: "G/W Actual", value: "actualGw", sortable: false },
        { text: "M3 Actual", value: "actualM3", sortable: false },
        { text: "ETA", value: "eta", sortable: false },
        { text: "ETD", value: "etd", sortable: false },
        { text: "陸揚港", value: "dischargePortCode", sortable: false },
        { text: "INVOICE NO", value: "invoiceNo", sortable: false },
        { text: "送信者", value: "senderName", sortable: false },
      ],
      query: {},
      pagination: {
        rowsPerPage: 10,
      },
      results: [],
      showResults: [],
      item: [
        { text: "送信済み", value: "sent" },
        { text: "未送信", value: "unsent" },
      ],
    };
  },
  methods: {
    getKey(blNo) {
      return blNo
        .replace(new RegExp("/", "g"), "_&_")
        .replace(/ /g, "_&_")
        .replace(/#/g, "_&_")
        .replace(/%/g, "_&_")
        .replace(/,/g, "_&_")
        .replace(/:/g, "_&_")
        .replace(/;/g, "_&_")
        .replace(/</g, "_&_")
        .replace(/=/g, "_&_")
        .replace(/>/g, "_&_")
        .replace(/@/g, "_&_");
    },
    getFile() {
      this.$http
        .get(`/files/bls/${this.getKey(this.selected[0].blNo)}/files`)
        .then((res) => {
          console.log(res.data);
        });
    },
    confirm() {
      this.$router.push({
        path: "/B1901",
        query: {
          id: this.selected[0].id,
          status: "CANCEL",
          type: "CANCEL",
        },
      });
    },
    reject() {
      this.$router.push({
        path: "/B1901",
        query: {
          id: this.selected[0].id,
          status: "CANCEL",
          type: "REMOVE",
        },
      });
    },
    cancel() {
      this.doBlSend();
    },
    blSend() {
      this.$http
        .get(`/shipping-advices/${this.selected[0].id}/valid-handle-status`)
        .then((res) => {
          if (!res.data) {
            this.$refs.confirm3.popup({
              title: "",
              content:
                "当該データに対してSAPよりCANCELデータを受信しました。SAを取り消しますか？",
              action: "登録済みSAの取消し",
              rejectAction: "CANCELデータを削除",
              cancelAction: "キャンセル（処理しないままBL確認完了送信）",
            });
          } else {
            this.doBlSend();
          }
        });
    },
    doBlSend() {
      if (
        !this.selected[0].actualCw &&
        this.selected[0].transportModeCode === "AIR"
      ) {
        this.$message("", "BL確認完了送信画面にCWをご記入ください。");
      } else {
        this.$http
          .get(`/files/bls/${this.getKey(this.selected[0].blNo)}/files`)
          .then((res) => {
            if (
              res.data.filter((f) => f.category === "invoice").length === 0 ||
              res.data.filter((f) => f.category === "bl").length === 0
            ) {
              this.$message(
                "",
                "BLまたはINV添付資料が無いので、確認完了通知メールを送信できません。"
              );
              return;
            } else {
              this.$http
                .get(`shipping-advices/${this.selected[0].id}/import`)
                .then((res) => {
                  let employees = res.data;
                  if (employees.length > 0) {
                    this.$http
                      .get(`shipping-advices/${this.selected[0].id}/has-sent`)
                      .then((r) => {
                        if (r.data === true) {
                          this.$confirm({
                            content: "すでに通知メール済ですが、送信しますか",
                          }).then(() => {
                            this.employee = res.data;
                            this.$refs.employeeDialog.popup(
                              this.selected[0].id
                            );
                            this.selected = [];
                            this.load();
                          });
                        } else {
                          this.employee = res.data;
                          this.$refs.employeeDialog.popup(this.selected[0].id);
                          this.selected = [];
                          this.load();
                        }
                      });
                  } else {
                    this.$message(
                      "",
                      "送信先が登録されていないため、ご確認ください。"
                    );
                  }
                });
            }
          });
      }
    },
    refresh() {
      this.selected = [];
      this.load();
    },
    params() {
      return {
        params: {
          ...this.query,
          ...this.$pageable(),
        },
      };
    },
    search() {
      this.pagination.page = 0;
      this.$storeParams();
      this.load();
    },
    infoInput() {
      this.$refs.blDlg.popup();
    },
    load() {
      this.autoload = true;
      this.$http
        .get("/shipping-advices?view=B1600", this.params())
        .then((res) => {
          this.pagination.page = res.data.number + 1;
          this.pagination.rowsPerPage = res.data.size;
          this.pagination.totalItems = res.data.totalElements;
          this.results = res.data.content;
          this.loading = false;
          this.selected = [];
        });
    },
    downloadData() {
      this.$http
        .get("/shipping-advices?view=B1600", {
          params: {
            ...this.query,
            ...this.$pageable(),
            size: 9999,
            page: 0,
          },
        })
        .then((res) => {
          var result = res.data.content.map((r) => {
            return {
              ...r,
              bu: r.buCode + ":" + r.buName,
            };
          });
          this.$exportTable(
            result,
            this.downloadHeaders.map((f) => f.value),
            this.downloadHeaders.map((f) => f.text),
            "BL確認データ出力"
          );
        });
    },
  },
  mounted() {
    this.$loadParams();
  },
  computed: {
    hasParam() {
      return (
        this.query.partnerId ||
        this.query.doNo ||
        this.query.blNo ||
        this.query.blIssueDateFrom ||
        this.query.blIssueDateTo ||
        this.query.transportModeId ||
        this.query.blSend ||
        this.query.roleId ||
        this.query.etdFrom ||
        this.query.etdTo
      );
    },
    hasAllUnpaid() {
      return this.selected.filter((s) => s.isAllUnpaid).length > 0;
    },
  },
  watch: {
    pagination() {
      if (this.autoload) this.load();
    },
  },
};
</script>
